import { Component, Inject } from '@angular/core';
import { MatDialogRef, MatDialogModule, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-confirmation-export-dialog',
    templateUrl: './confirmation-export-dialog.component.html',
    styleUrls: ['./confirmation-export-dialog.component.scss'],
    imports: [
        MatDialogModule,
        TranslateModule
    ]
})
export class ConfirmationExportDialogComponent {
  public exportLabelKey: string;

  constructor(
    public dialogRef: MatDialogRef<ConfirmationExportDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { exportLabelKey?: string } | null
  ) {
    this.exportLabelKey = (data && data.exportLabelKey) ? data.exportLabelKey : 'TAGS_MANAGEMENT.EXPORT_EXCEL';
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
